import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const NavContainerShort = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 12,
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  gap: '8px',
  backgroundColor: theme.palette.secondary.main,
  borderRadius: 40,
  padding: "8px 16px",
  boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
  zIndex: 1000,

  "& .nav-button": {
    // base button styles
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 32,
    padding: "8px",
    fontSize: 14,
    cursor: "pointer",
    color: theme.palette.common.white,
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    gap: '0px',
    overflow: "hidden",
    whiteSpace: "nowrap",
    minWidth: 0,

    // COLLAPSED state: only icon visible
    maxWidth: 40,
    transition: "max-width 0.3s ease-in-out, background-color 0.2s ease-in-out",

    "& svg": {
      fill: theme.palette.common.white,
      width: 24,
      height: 24,
      /* minWidth: 24, */
      flexShrink: 0,
    },

        // hide text by default
    "& .nav-text": {
      opacity: 0,
      transition: "opacity 0.3s ease-in-out",
      /* display: "inline-block", */
      flexShrink: 1,
      minWidth: 0,    
    },

    // EXPANDED on hover
    "&:hover, &.selected": {
      backgroundColor: theme.palette.secondary.dark,
      color: theme.palette.primary.main,
      maxWidth: 180,                // allow room for icon + text
      padding: "8px 16px",          // expand padding horizontally

      "& svg": {
        fill: theme.palette.primary.main,
      },

      // fade text in
      "& .nav-text": {
        opacity: 1,
        marginLeft: 10,
      },
    },



    /* "&:focus": {
      outline: "none",
    }, */
  }
}));
